import styled, { css } from 'styled-components'

import { Copy2Icon, Typography } from '@blade/ui-kit'
import { useClipboard } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { mediaMaxMobile, Separator } from '@root/shared/ui-kit'

import type { CurrencyModel } from '@root/entities/currency'

type Mode = 'primary' | 'secondary'

type Props = {
  currency: CurrencyModel
  mode?: Mode | undefined
}

export const PremiumCurrencyInfoAddress: React.FC<Props> = ({
  currency,
  mode = 'primary',
}) => {
  const { t } = useTranslation()
  const { copyToClipboard } = useClipboard()

  const handleCopy = () => {
    copyToClipboard(currency.address, {
      showSnackbar: true,
      snackbarText: t('currency.token_address_copied_message', {
        ticker: currency.ticker,
      }),
    })
  }

  return (
    <Address type="button" onClick={handleCopy} $mode={mode}>
      <CurrencyAddress>{currency.address}</CurrencyAddress>
      <Separator
        vertical
        css={css`
          height: 30px;
        `}
      />
      <Copy size={16} />
    </Address>
  )
}

const Address = styled.button<{ $mode: Mode | undefined }>`
  all: unset;
  border: 1px solid var(--background-3);
  background: ${(props) =>
    props.$mode === 'primary' ? 'var(--appearance-1)' : 'var(--background-1)'};

  cursor: pointer;

  display: grid;
  grid-template-columns: 1fr auto auto;
  align-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  height: 40px;
  padding: 0 16px;
  width: auto;

  ${mediaMaxMobile(css`
    width: 252px;
    justify-self: center;
  `)}
`

const CurrencyAddress = styled(Typography).attrs({
  variant: 'body4-regular',
  component: 'span',
  ellipsis: true,
})`
  color: var(--text-11);
  text-align: left;
`

const Copy = styled(Copy2Icon)`
  color: var(--text-12);
`
